import * as tslib_1 from "tslib";
import { NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
var NgbTimeConverter = /** @class */ (function (_super) {
    tslib_1.__extends(NgbTimeConverter, _super);
    function NgbTimeConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbTimeConverter.prototype.fromModel = function (timeString) {
        if (!timeString) {
            return null;
        }
        var parts = timeString.split(':', 3);
        return {
            hour: parseInt(parts[0], 10),
            minute: parseInt(parts[1], 10),
            second: parseInt(parts[2], 10)
        };
    };
    NgbTimeConverter.prototype.toModel = function (time) {
        if (!time) {
            return null;
        }
        time.hour = (time.hour) ? time.hour : 0;
        time.minute = (time.minute) ? time.minute : 0;
        time.second = (time.second) ? time.second : 0;
        return this.pad(time.hour) + ":" + this.pad(time.minute) + ":" + this.pad(time.second);
    };
    NgbTimeConverter.prototype.pad = function (number) {
        return number < 10 ? "0" + number : number;
    };
    return NgbTimeConverter;
}(NgbTimeAdapter));
export { NgbTimeConverter };



// WEBPACK FOOTER //
// ./src/app/bi/common/service/ngbTimeConverter.utils.ts.pre-build-optimizer.js